import React, { PureComponent, Component, Fragment } from 'react';
import * as d3 from 'd3';
import "./hb-index-chart-component.css"


class Rect extends PureComponent {

  state = {
    x: this.props.xScale(0),
    y: this.props.y,
    d: this.props.d,
    width: 0,
    mounted: false,
    transitioning: true
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.width !== this.state.width || nextProps.x !== this.state.x) {
      this.setState({
        width: 0,
        x: nextProps.xScale(0),
        transitioning: true
      }, () => {
        setTimeout(() => {
          this.setState({
            x: nextProps.x,
            y: nextProps.y,
            d: nextProps.d,
            width: nextProps.width,
            transitioning: false
          });
        }, 400)
      });
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        width: this.props.width,
        x: this.props.x,
        y: this.props.y,
        mounted: true,
        transitioning: false
      });
    }, 400)
  }

  render() {
    const { x, y, d, width } = this.state;
    const { hover, unhover, hovered, index, hoverIndex, svgWidth } = this.props;
    return (
      <g>
        {
          this.state.mounted
            ?
            <Fragment>
              {
                this.state.transitioning
                  ?
                  null
                  :
                  <Fragment>
                    <line
                      className="hb_index__line"
                      x1={0}
                      y1={y + 15}
                      x2={svgWidth + 5}
                      y2={y + 15}
                      strokeWidth="0.3"
                      stroke="rgba(0, 0, 0, 0.6)"
                    />
                    <text
                      fontSize="16px"
                      x={svgWidth + 10}
                      y={y + 20}
                    >
                      { d.score || 'unspecified' }
                    </text>
                  </Fragment>
              }

            </Fragment>
            :
            null
        }
        <rect
          className="hb_index__rect"
          x={x}
          y={y}
          fill={d.hb_index > 0
            ?
            hoverIndex === index
              ?
              '#57d157'
              :
              'rgba(44, 160, 44, 1)'
            :
            hoverIndex === index
              ?
              '#e05757'
              :
              'rgba(214, 39, 40, 1)'
          }
          width={width}
          height={30}
          ref="rect"
          onMouseMove={e => hover({
            left: e.clientX,
            top: e.clientY,
            score: d.score,
            hbIndex: d.hb_index,
            hoverIndex: index
          })}
          onMouseOut={e => unhover()}
        />
      </g>
    )
  }
}


class HBIndexChart extends Component {


  state = {
    hovered: false,
    score: "",
    hbIndex: null,
    top: 0,
    left: 0,
    hoverIndex: null,
    transitioning: true
  };

  hover = ({ score, hbIndex, top, left, hoverIndex }) => {
    this.setState({ hovered: true, score, hbIndex, top, left: left + 30, hoverIndex });
  };
  unhover = () => {
    this.setState({ hovered: false, score: "", hbIndex: null, hoverIndex: null });
  };

  height = 300;
  width = 800;
  characterWidth = 6.5;

  drawChart = () => {
    this.setState({transitioning: true}, () => {
      this.height = this.props.data.length * 45 + 30;
      this.width = 770 - this.props.data.max * this.characterWidth;
      console.log(this.width, 'THIS WIDTH');
      this.x = d3.scaleLinear()
        .range([0, this.width])
        .domain([-1.3, 1]);
      this.y = d3.scaleBand()
        .rangeRound([0, this.height - 40])
        .paddingInner(0.1)
        .domain(this.props.data.map(d => d.score));

      const svg = d3.select('svg');

      const xAxis = d3.axisBottom()
        .scale(this.x);

      const axisSelection = d3.select(".axis");
      if (axisSelection.empty()) {
        svg.append("g")
          .attr("fill", "rgba(0, 0, 0, 0.5)")
          .attr("class", "axis")
          .attr('transform', `translate(-0.5, ${this.height - 20})`)
          .call(xAxis);
      } else {
        axisSelection.remove();
        svg.append("g")
          .attr("fill", "rgba(0, 0, 0, 0.5)")
          .attr("class", "axis")
          .attr('transform', `translate(-0.5, ${this.height - 20})`)
          .call(xAxis);
      }
      d3.selectAll('path').attr('stroke', 'rgba(0, 0, 0, 0.5');
      d3.selectAll('line').attr('stroke', 'rgba(0, 0, 0, 0.5');
      setTimeout(() => this.setState({transitioning: false}), 300);
      this.forceUpdate();
    })

  };

  componentDidMount() {
    if (this.props.data.length) {
      this.drawChart();
      console.log('chart was drawn in component did mount')
    }

  }

  componentDidUpdate(prevProps) {
    if (this.props.data.length && JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
      this.drawChart();
      console.log('chart was drawn im component did update')
    }
  }

  render() {
    const { data } = this.props;
    return (
      <Fragment>
        <svg height={this.height} width={800} transform={`translate(0, 0)`}>
          <g transform={`translate(0, 20)`}>
            {
              this.x && this.y
              ?
              data.map((d, i) => {
                const x = this.x(Math.min(0, d.hb_index));
                const y = this.y(d.score) || 0;
                const width = Math.abs(this.x(d.hb_index) - this.x(0));
                const height = this.y.bandwidth();
                return (
                  <Rect
                    key={i}
                    index={i}
                    hoverIndex={this.state.hoverIndex}
                    x={x}
                    y={y}
                    d={d}
                    xScale={this.x}
                    yScale={this.y}
                    width={width}
                    hover={this.hover}
                    unhover={this.unhover}
                    hovered={this.state.hovered}
                    svgWidth={this.width}
                  />
                )
              })
                : null
            }
          </g>
          {
            this.state.transitioning
            ?
              null
              :
              <line
                x1={this.x && this.x(0)}
                y1={this.height - 20}
                x2={this.x && this.x(0)}
                y2={10}
                stroke="rgba(0, 0, 0, 0.5)"
              />
          }
        </svg>
        <div
          style={{
            display: this.state.hovered ? 'flex' : 'none',
            backgroundColor: 'lightsteelblue',
            position: 'fixed',
            top: this.state.top,
            left: this.state.left,
            flexDirection: 'column',
            padding: '10px',
            borderRadius: '8px',
            zIndex: '100000',
            textAlign: 'left',
            width: '250px'
          }}
        >
          <div>
            <span style={{
              fontWeight: '400',
              marginRight: '3px'
            }}>Score:</span>
            <span>{this.state.score}</span>
          </div>
          <div>
            <span style={{
              fontWeight: '400',
              marginRight: '3px'
            }}>HB Index:</span>
            <span>{Number(this.state.hbIndex).toFixed(3)}</span>
          </div>
        </div>
      </Fragment>
    )
  }
}


export default HBIndexChart;


// WEBPACK FOOTER //
// ./src/components/hb-index-chart/hb-index-chart-component.js